import type { GroupRule } from 'flow/service/rules';
import { isAmbiguousGroup } from 'flow/service/rules';

export function hasAmbiguousChildren(rule: GroupRule) {
  return Boolean(
    rule.data.children.find(
      child => isAmbiguousGroup(child),
    ),
  );
}
